function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
!function () {
  "use strict";

  function t(t, e) {
    e = e || {
      bubbles: !1,
      cancelable: !1,
      detail: void 0
    };
    var n = document.createEvent("CustomEvent");
    return n.initCustomEvent(t, e.bubbles, e.cancelable, e.detail), n;
  }
  "".trim || (String.prototype.trim = function () {
    return this.replace(/^[\s﻿]+|[\s﻿]+$/g, "");
  }), window.NodeList && !NodeList.prototype.forEach && (NodeList.prototype.forEach = Array.prototype.forEach), Array.prototype.findIndex || Object.defineProperty(Array.prototype, "findIndex", {
    value: function value(t) {
      if (null == this) throw new TypeError('"this" is null or not defined');
      var e = Object(this),
        n = e.length >>> 0;
      if ("function" != typeof t) throw new TypeError("predicate must be a function");
      for (var r = arguments[1], i = 0; i < n;) {
        var o = e[i];
        if (t.call(r, o, i, e)) return i;
        i++;
      }
      return -1;
    },
    configurable: !0,
    writable: !0
  }), String.prototype.includes || (String.prototype.includes = function (t, e) {
    return "number" != typeof e && (e = 0), !(e + t.length > this.length) && -1 !== this.indexOf(t, e);
  }), "function" != typeof Object.assign && Object.defineProperty(Object, "assign", {
    value: function value(t, e) {
      if (null == t) throw new TypeError("Cannot convert undefined or null to object");
      for (var n = Object(t), r = 1; r < arguments.length; r++) {
        var i = arguments[r];
        if (null != i) for (var o in i) {
          Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
        }
      }
      return n;
    },
    writable: !0,
    configurable: !0
  }), t.prototype = window.Event.prototype, "function" != typeof window.CustomEvent && (window.CustomEvent = t), Element.prototype.matches || (Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector), Element.prototype.closest || (Element.prototype.closest = function (t) {
    var e = this;
    if (!document.documentElement.contains(e)) return null;
    do {
      if (e.matches(t)) return e;
      e = e.parentElement || e.parentNode;
    } while (null !== e && 1 === e.nodeType);
    return null;
  }), document.execCommand("AutoUrlDetect", !1, !1), "document" in self && ("classList" in document.createElement("_") && (!document.createElementNS || "classList" in document.createElementNS("http://www.w3.org/2000/svg", "g")) || function (t) {
    if ("Element" in t) {
      var e = "classList",
        n = "prototype",
        r = t.Element[n],
        i = Object,
        o = String[n].trim || function () {
          return this.replace(/^\s+|\s+$/g, "");
        },
        s = Array[n].indexOf || function (t) {
          for (var e = 0, n = this.length; e < n; e++) {
            if (e in this && this[e] === t) return e;
          }
          return -1;
        },
        u = function u(t, e) {
          this.name = t, this.code = DOMException[t], this.message = e;
        },
        c = function c(t, e) {
          if ("" === e) throw new u("SYNTAX_ERR", "The token must not be empty.");
          if (/\s/.test(e)) throw new u("INVALID_CHARACTER_ERR", "The token must not contain space characters.");
          return s.call(t, e);
        },
        a = function a(t) {
          for (var e = o.call(t.getAttribute("class") || ""), n = e ? e.split(/\s+/) : [], r = 0, i = n.length; r < i; r++) {
            this.push(n[r]);
          }
          this._updateClassName = function () {
            t.setAttribute("class", this.toString());
          };
        },
        f = a[n] = [],
        l = function l() {
          return new a(this);
        };
      if (u[n] = Error[n], f.item = function (t) {
        return this[t] || null;
      }, f.contains = function (t) {
        return ~c(this, t + "");
      }, f.add = function () {
        for (var t, e = arguments, n = 0, r = e.length, i = !1; ~c(this, t = e[n] + "") || (this.push(t), i = !0), ++n < r;) {
          ;
        }
        i && this._updateClassName();
      }, f.remove = function () {
        var t,
          e,
          n = arguments,
          r = 0,
          i = n.length,
          o = !1;
        do {
          for (e = c(this, t = n[r] + ""); ~e;) {
            this.splice(e, 1), o = !0, e = c(this, t);
          }
        } while (++r < i);
        o && this._updateClassName();
      }, f.toggle = function (t, e) {
        var n = this.contains(t),
          r = n ? !0 !== e && "remove" : !1 !== e && "add";
        return r && this[r](t), !0 === e || !1 === e ? e : !n;
      }, f.replace = function (t, e) {
        var n = c(t + "");
        ~n && (this.splice(n, 1, e), this._updateClassName());
      }, f.toString = function () {
        return this.join(" ");
      }, i.defineProperty) {
        var h = {
          get: l,
          enumerable: !0,
          configurable: !0
        };
        try {
          i.defineProperty(r, e, h);
        } catch (t) {
          void 0 !== t.number && -2146823252 !== t.number || (h.enumerable = !1, i.defineProperty(r, e, h));
        }
      } else i[n].__defineGetter__ && r.__defineGetter__(e, l);
    }
  }(self), function () {
    var t = document.createElement("_");
    if (t.classList.add("c1", "c2"), !t.classList.contains("c2")) {
      var e = function e(t) {
        var r = DOMTokenList.prototype[t];
        DOMTokenList.prototype[t] = function (t) {
          var e,
            n = arguments.length;
          for (e = 0; e < n; e++) {
            t = arguments[e], r.call(this, t);
          }
        };
      };
      e("add"), e("remove");
    }
    if (t.classList.toggle("c3", !1), t.classList.contains("c3")) {
      var n = DOMTokenList.prototype.toggle;
      DOMTokenList.prototype.toggle = function (t, e) {
        return 1 in arguments && !this.contains(t) == !e ? e : n.call(this, t);
      };
    }
    "replace" in document.createElement("_").classList || (DOMTokenList.prototype.replace = function (t, e) {
      var n = this.toString().split(" "),
        r = n.indexOf(t + "");
      ~r && (n = n.slice(r), this.remove.apply(this, n), this.add(e), this.add.apply(this, n.slice(1)));
    }), t = null;
  }()), window.Promise = function () {
    "use strict";

    function r(t) {
      var e = _typeof(t);
      return t !== null && (e === "object" || e === "function");
    }
    function c(t) {
      return typeof t === "function";
    }
    var t = void 0;
    if (Array.isArray) {
      t = Array.isArray;
    } else {
      t = function t(_t) {
        return Object.prototype.toString.call(_t) === "[object Array]";
      };
    }
    var n = t,
      i = 0,
      e = void 0,
      o = void 0,
      s = function t(e, n) {
        g[i] = e;
        g[i + 1] = n;
        i += 2;
        if (i === 2) {
          if (o) {
            o(w);
          } else {
            A();
          }
        }
      };
    function u(t) {
      o = t;
    }
    function a(t) {
      s = t;
    }
    var f = typeof window !== "undefined" ? window : undefined,
      l = f || {},
      h = l.MutationObserver || l.WebKitMutationObserver,
      p = typeof self === "undefined" && typeof process !== "undefined" && {}.toString.call(process) === "[object process]",
      d = typeof Uint8ClampedArray !== "undefined" && typeof importScripts !== "undefined" && typeof MessageChannel !== "undefined";
    function v() {
      return function () {
        return process.nextTick(w);
      };
    }
    function y() {
      if (typeof e !== "undefined") {
        return function () {
          e(w);
        };
      }
      return b();
    }
    function m() {
      var t = 0;
      var e = new h(w);
      var n = document.createTextNode("");
      e.observe(n, {
        characterData: true
      });
      return function () {
        n.data = t = ++t % 2;
      };
    }
    function _() {
      var t = new MessageChannel();
      t.port1.onmessage = w;
      return function () {
        return t.port2.postMessage(0);
      };
    }
    function b() {
      var t = setTimeout;
      return function () {
        return t(w, 1);
      };
    }
    var g = new Array(1e3);
    function w() {
      for (var t = 0; t < i; t += 2) {
        var e = g[t];
        var n = g[t + 1];
        e(n);
        g[t] = undefined;
        g[t + 1] = undefined;
      }
      i = 0;
    }
    function E() {
      try {
        var t = Function("return this")().require("vertx");
        e = t.runOnLoop || t.runOnContext;
        return y();
      } catch (t) {
        return b();
      }
    }
    var A = void 0;
    if (p) {
      A = v();
    } else if (h) {
      A = m();
    } else if (d) {
      A = _();
    } else if (f === undefined && typeof require === "function") {
      A = E();
    } else {
      A = b();
    }
    function O(t, e) {
      var n = this;
      var r = new this.constructor(T);
      if (r[j] === undefined) {
        W(r);
      }
      var i = n._state;
      if (i) {
        var o = arguments[i - 1];
        s(function () {
          return $(i, r, o, n._result);
        });
      } else {
        G(n, r, t, e);
      }
      return r;
    }
    function S(t) {
      var e = this;
      if (t && _typeof(t) === "object" && t.constructor === e) {
        return t;
      }
      var n = new e(T);
      Y(n, t);
      return n;
    }
    var j = Math.random().toString(36).substring(2);
    function T() {}
    var C = void 0,
      L = 1,
      P = 2;
    function M() {
      return new TypeError("You cannot resolve a promise with itself");
    }
    function N() {
      return new TypeError("A promises callback cannot return that same promise.");
    }
    function k(t, e, n, r) {
      try {
        t.call(e, n, r);
      } catch (t) {
        return t;
      }
    }
    function x(t, r, i) {
      s(function (e) {
        var n = false;
        var t = k(i, r, function (t) {
          if (n) {
            return;
          }
          n = true;
          if (r !== t) {
            Y(e, t);
          } else {
            I(e, t);
          }
        }, function (t) {
          if (n) {
            return;
          }
          n = true;
          q(e, t);
        }, "Settle: " + (e._label || " unknown promise"));
        if (!n && t) {
          n = true;
          q(e, t);
        }
      }, t);
    }
    function D(e, t) {
      if (t._state === L) {
        I(e, t._result);
      } else if (t._state === P) {
        q(e, t._result);
      } else {
        G(t, undefined, function (t) {
          return Y(e, t);
        }, function (t) {
          return q(e, t);
        });
      }
    }
    function R(t, e, n) {
      if (e.constructor === t.constructor && n === O && e.constructor.resolve === S) {
        D(t, e);
      } else {
        if (n === undefined) {
          I(t, e);
        } else if (c(n)) {
          x(t, e, n);
        } else {
          I(t, e);
        }
      }
    }
    function Y(e, t) {
      if (e === t) {
        q(e, M());
      } else if (r(t)) {
        var n = void 0;
        try {
          n = t.then;
        } catch (t) {
          q(e, t);
          return;
        }
        R(e, t, n);
      } else {
        I(e, t);
      }
    }
    function F(t) {
      if (t._onerror) {
        t._onerror(t._result);
      }
      U(t);
    }
    function I(t, e) {
      if (t._state !== C) {
        return;
      }
      t._result = e;
      t._state = L;
      if (t._subscribers.length !== 0) {
        s(U, t);
      }
    }
    function q(t, e) {
      if (t._state !== C) {
        return;
      }
      t._state = P;
      t._result = e;
      s(F, t);
    }
    function G(t, e, n, r) {
      var i = t._subscribers;
      var o = i.length;
      t._onerror = null;
      i[o] = e;
      i[o + L] = n;
      i[o + P] = r;
      if (o === 0 && t._state) {
        s(U, t);
      }
    }
    function U(t) {
      var e = t._subscribers;
      var n = t._state;
      if (e.length === 0) {
        return;
      }
      var r = void 0,
        i = void 0,
        o = t._result;
      for (var s = 0; s < e.length; s += 3) {
        r = e[s];
        i = e[s + n];
        if (r) {
          $(n, r, i, o);
        } else {
          i(o);
        }
      }
      t._subscribers.length = 0;
    }
    function $(t, e, n, r) {
      var i = c(n),
        o = void 0,
        s = void 0,
        u = true;
      if (i) {
        try {
          o = n(r);
        } catch (t) {
          u = false;
          s = t;
        }
        if (e === o) {
          q(e, N());
          return;
        }
      } else {
        o = r;
      }
      if (e._state !== C) {} else if (i && u) {
        Y(e, o);
      } else if (u === false) {
        q(e, s);
      } else if (t === L) {
        I(e, o);
      } else if (t === P) {
        q(e, o);
      }
    }
    function H(n, t) {
      try {
        t(function t(e) {
          Y(n, e);
        }, function t(e) {
          q(n, e);
        });
      } catch (t) {
        q(n, t);
      }
    }
    var K = 0;
    function V() {
      return K++;
    }
    function W(t) {
      t[j] = K++;
      t._state = undefined;
      t._result = undefined;
      t._subscribers = [];
    }
    function X() {
      return new Error("Array Methods must be provided an Array");
    }
    var z = function () {
      function t(t, e) {
        this._instanceConstructor = t;
        this.promise = new t(T);
        if (!this.promise[j]) {
          W(this.promise);
        }
        if (n(e)) {
          this.length = e.length;
          this._remaining = e.length;
          this._result = new Array(this.length);
          if (this.length === 0) {
            I(this.promise, this._result);
          } else {
            this.length = this.length || 0;
            this._enumerate(e);
            if (this._remaining === 0) {
              I(this.promise, this._result);
            }
          }
        } else {
          q(this.promise, X());
        }
      }
      t.prototype._enumerate = function t(e) {
        for (var n = 0; this._state === C && n < e.length; n++) {
          this._eachEntry(e[n], n);
        }
      };
      t.prototype._eachEntry = function t(e, n) {
        var r = this._instanceConstructor;
        var i = r.resolve;
        if (i === S) {
          var o = void 0;
          var s = void 0;
          var u = false;
          try {
            o = e.then;
          } catch (t) {
            u = true;
            s = t;
          }
          if (o === O && e._state !== C) {
            this._settledAt(e._state, n, e._result);
          } else if (typeof o !== "function") {
            this._remaining--;
            this._result[n] = e;
          } else if (r === et) {
            var c = new r(T);
            if (u) {
              q(c, s);
            } else {
              R(c, e, o);
            }
            this._willSettleAt(c, n);
          } else {
            this._willSettleAt(new r(function (t) {
              return t(e);
            }), n);
          }
        } else {
          this._willSettleAt(i(e), n);
        }
      };
      t.prototype._settledAt = function t(e, n, r) {
        var i = this.promise;
        if (i._state === C) {
          this._remaining--;
          if (e === P) {
            q(i, r);
          } else {
            this._result[n] = r;
          }
        }
        if (this._remaining === 0) {
          I(i, this._result);
        }
      };
      t.prototype._willSettleAt = function t(e, n) {
        var r = this;
        G(e, undefined, function (t) {
          return r._settledAt(L, n, t);
        }, function (t) {
          return r._settledAt(P, n, t);
        });
      };
      return t;
    }();
    function B(t) {
      return new z(this, t).promise;
    }
    function J(i) {
      var o = this;
      if (n(i)) return new o(function (t, e) {
        for (var n = i.length, r = 0; r < n; r++) {
          o.resolve(i[r]).then(t, e);
        }
      });else return new o(function (t, e) {
        return e(new TypeError("You must pass an array to race."));
      });
    }
    function Q(t) {
      var e = new this(T);
      return q(e, t), e;
    }
    function Z() {
      throw new TypeError("You must pass a resolver function as the first argument to the promise constructor");
    }
    function tt() {
      throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
    }
    var et = function () {
      function e(t) {
        this[j] = V();
        this._result = this._state = undefined;
        this._subscribers = [];
        if (T !== t) {
          typeof t !== "function" && Z();
          this instanceof e ? H(this, t) : tt();
        }
      }
      e.prototype["catch"] = function t(e) {
        return this.then(null, e);
      };
      e.prototype["finally"] = function t(e) {
        var n = this;
        var r = n.constructor;
        if (c(e)) {
          return n.then(function (t) {
            return r.resolve(e()).then(function () {
              return t;
            });
          }, function (t) {
            return r.resolve(e()).then(function () {
              throw t;
            });
          });
        }
        return n.then(e, e);
      };
      return e;
    }();
    function nt() {
      var t = void 0;
      if ("undefined" != typeof global) t = global;else if ("undefined" != typeof self) t = self;else try {
        t = Function("return this")();
      } catch (t) {
        throw new Error("polyfill failed because global object is unavailable in this environment");
      }
      var e = t.Promise;
      if (e) {
        var n = null;
        try {
          n = Object.prototype.toString.call(e.resolve());
        } catch (t) {}
        if ("[object Promise]" === n && !e.cast) return;
      }
      t.Promise = et;
    }
    return et.prototype.then = O, et.all = function (t) {
      return new z(this, t).promise;
    }, et.race = function (i) {
      var o = this;
      return n(i) ? new o(function (t, e) {
        for (var n = i.length, r = 0; r < n; r++) {
          o.resolve(i[r]).then(t, e);
        }
      }) : new o(function (t, e) {
        return e(new TypeError("You must pass an array to race."));
      });
    }, et.resolve = S, et.reject = function (t) {
      var e = new this(T);
      return q(e, t), e;
    }, et._setScheduler = function (t) {
      o = t;
    }, et._setAsap = function (t) {
      s = t;
    }, et._asap = s, et.polyfill = function () {
      var t = void 0;
      if ("undefined" != typeof global) t = global;else if ("undefined" != typeof self) t = self;else try {
        t = Function("return this")();
      } catch (t) {
        throw new Error("polyfill failed because global object is unavailable in this environment");
      }
      var e = t.Promise;
      if (e) {
        var n = null;
        try {
          n = Object.prototype.toString.call(e.resolve());
        } catch (t) {}
        if ("[object Promise]" === n && !e.cast) return;
      }
      t.Promise = et;
    }, et.Promise = et;
  }();
}();